import classNames from 'classnames';
import { Icon } from '@modulor/react';
import React from 'react';
import { ButtonWithAnalytics } from '../../ui-components/Button/Button';
import SeoLink from '../../SeoLink/SeoLink';
import { useIsDesktopLayout } from '../../../hooks/useMediaQuery';
import {
  usePromoBonusesPageRedirectCallback,
  usePromoBonusUrl,
} from '../../../hooks/usePromoBonusSystemRedirects';
import { PROMO } from '../../../constants/productTypes';
import styles from './NavigationItem.module.css';

const BonusNavigationItem = ({
  icon,
  count,
  children,
  dataLayerEventData,
  ...props
}: any) => {
  const isDesktop = useIsDesktopLayout();
  const redirectToBonusList = usePromoBonusesPageRedirectCallback();
  const promoBonusesUrl = usePromoBonusUrl();

  return (
    <SeoLink productType={PROMO} url={promoBonusesUrl}>
      <ButtonWithAnalytics
        onClick={redirectToBonusList}
        className={classNames(styles['NavigationItem'], styles.promo)}
        dataLayerEventData={dataLayerEventData}
        {...props}
      >
        <div className={styles['icon']}>{icon}</div>
        <div className={styles['text']}>
          {children}
          {count && <div className={styles['count']}>{count}</div>}
          {!isDesktop && (
            <Icon name="chevron_right" size={24} className={styles['arrow']} />
          )}
        </div>
      </ButtonWithAnalytics>
    </SeoLink>
  );
};

export default BonusNavigationItem;
